module.exports = __webpack_public_path__ + "static/img/5.e12c7bd6.png";